import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AppTranslateService {

  constructor(private translate : TranslateService) { }

  translateText(key: string) {
    var value: string = '';
    this.translate.get(key).subscribe((res: string) => { value = res });
    return value;
  }

}

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
